export default __webpack_public_path__ + "static/media/polygon-white.79f48ae8.png";